<template>
  <div class="service-list">
    <div class="list-service-appointment">
      <img class="icon" :src="iconUrl" v-if="iconUrl" />
      <div class="meta" :class="metaClassList">
        <router-link class="name" :to="route" v-if="route">{{
          name
        }}</router-link>
        <h4 class="name" v-else>{{ name }}</h4>
        <p class="desc">{{ desc }}</p>
        <p v-if="mainOptionTitle">Option หลัก: {{ mainOptionTitle }}</p>
        <p v-if="extraOptionTitles">Option เสริม: {{ extraOptionTitles }}</p>
        <div class="provider">
          <img class="logo" :src="provider.logoUrl" v-if="provider.logoUrl" />
          <p class="name">{{ provider.name }}</p>
        </div>
        <div class="name" v-if="qualityUnitText"> {{ qualityUnitText }}</div>
      </div>
    </div>
    <div class="appointment" v-if="appointmentDate">
      <div class="count">{{ appointmentQuota }}</div>
      <div class="date">{{ appointmentDate }}</div>
      <div class="clear-both"></div> 
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "iconUrl",
    "name",
    "shortDescription",
    "description",
    "provider",
    "route",
    "quota",
    "appointmentCount",
    "currentAppointmentDate",
    "totalAppointment",
    "mainOptionTitle",
    "extraOptionTitles",
    "qualityUnit"
  ],
  computed: {
    desc() {
      if (!this.description) {
        return this.shortDescription;
      }

      if (!this.shortDescription) {
        return this.description;
      }

      if (!this.shortDescription && !this.description) {
        return "-";
      }

      return `${this.shortDescription} — ${this.description}`;
    },
    metaClassList() {
      return { "no-icon": !Boolean(this.iconUrl) };
    },
    appointmentQuota() {
      return this.totalAppointment
        ? `จำนวนครั้ง ${this.appointmentCount}/${this.totalAppointment}`
        : 'สินค้า'
    },
    appointmentDate() {
      return `นัดหมายล่าสุด: ${this.currentAppointmentDate}`
    },
    qualityUnitText() {
      return !this.totalAppointment
        ? this.qualityUnit
        : undefined
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$logoSize: 64px;

.service-list {
  border-bottom: $border;
}

.list-service-appointment {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;

  padding: ($space / 2) $space;

  > .icon {
    margin-top: 5px;
    display: block;

    border-radius: 8px;
    width: $logoSize;
    height: $logoSize;
    flex: 0 0 $logoSize;
  }

  > .icon + .meta {
    padding-left: $space;
  }

  > .meta {
    display: block;

    flex-grow: 1;
  }
}

.meta {
  min-width: 0;

  > .name {
    display: inline-block;
    font-size: 1rem;

    &:hover {
      color: black;
    }
  }

  > .desc {
    overflow: hidden;
    height: 23px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  > .provider {
    margin-top: 5px;
  }
}

.meta p {
  line-height: 1.6;
  font-size: 0.9rem;
  color: #777;
}

.provider {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .logo {
    margin-right: 12px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}

.appointment {
  font-size: 1rem;

  > .count {
    float: left;
  }

  > .date {
    float: right;
  }

  > .clear-both {
    clear: both;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/subscribers/components/ListServiceAppointment.vue